function topNewsSlider(){
	var topics = setInterval(function(){
		$('.section--top--mainvisual__news .btn li:nth-of-type(2) a').trigger('click');
	}, 3000);

	$(document).on('mouseover', '.section--top--mainvisual__news .btn li a',function(e){
		clearInterval(topics);
	});
	$(document).on('mouseout', '.section--top--mainvisual__news .btn li a',function(e){
		topics = setInterval(function(){
			$('.section--top--mainvisual__news .btn li:nth-of-type(2) a').trigger('click');
		}, 3000);
	});
}

module.exports = topNewsSlider;



// WEBPACK FOOTER //
// ./es2015/_top_news_slider.js